// Generated by Melange

import * as Buhta_cabinet__Api from "./Api.js";
import * as Buhta_cabinet__Crm from "../models/Crm.js";
import * as Buhta_cabinet__Forms from "../models/Forms.js";
import * as Buhta_cabinet__Request from "./Request.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_dictapis__Buhta_dict_v1_bank_service from "../../../../proto/dictapis/gen/buhta_dict_v1_bank_service.js";
import * as Curry from "melange.js/curry.js";

function sendMessage(param, org, id, message) {
  const url = Curry._3(Buhta_cabinet__Api.Endpoints.Crm.orgTickets, String(org), id, undefined);
  const payload = {};
  payload["type"] = "replied";
  payload["body"] = message;
  return Buhta_cabinet__Request.put(undefined, undefined, Buhta_cabinet__Crm.Ticket.Action.decode, url, payload);
}

function createTicket(param, org, state) {
  const url = Curry._3(Buhta_cabinet__Api.Endpoints.Crm.orgTickets, String(org), undefined, undefined);
  const payload = Buhta_cabinet__Forms.TicketForm.encode(state);
  return Buhta_cabinet__Request.post(undefined, undefined, Buhta_cabinet__Crm.Ticket.decodeDetailed, url, payload);
}

const TicketService = {
  sendMessage: sendMessage,
  createTicket: createTicket
};

const CrmService = {
  TicketService: TicketService
};

function getBanks(tenant, params, param) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.banks;
              }), Buhta_core__Grpc.makeRpc(Curry._1(Buhta_dictapis__Buhta_dict_v1_bank_service.Buhta.Dict.V1.ListBanksRequest.make, undefined), Buhta_dictapis__Buhta_dict_v1_bank_service.Buhta.Dict.V1.BankService.listBanks, undefined, undefined, undefined, "/dict" + Buhta_dictapis__Buhta_dict_v1_bank_service.Buhta.Dict.V1.BankService.ListBanks.name, undefined, undefined));
}

const BankService = {
  getBanks: getBanks
};

export {
  CrmService ,
  BankService ,
}
/* Buhta_cabinet__Crm Not a pure module */
